<template>
  <div class="header">
    <nav class="navbar">
      <div class="container-fluid">
        <div class="logo">
          <img
            :src="require('@/assets/images/' + navbarLogoName)"
            class="img-fluid"
            @click="goHome"
          />
        </div>
        <div class="nav-mainTitle">
          <div
            class="text-wrap"
            v-if="titleObj"
          >
            <router-link
              :to="{path:titleObj.path}"
              tag="span"
            >{{ titleObj.value }}</router-link>
            <span
              class="text-wrap-underline"
              v-if="title===titleObj.key"
            ></span>
          </div>
          <div
            class="text-verbar"
            v-if="titleObj && couponTitleVisible"
          >|</div>
          <div class="text-wrap" v-if="couponTitleVisible">
            <router-link
              :to="{path:'/coupon'}"
              tag="span"
            >Coupon著數</router-link>
            <span
              class="text-wrap-underline"
              v-if="title==='coupon'"
            ></span>
          </div>
        </div>
        <div class="nav-menu">
          <!-- <div class="nav-language">
            <span
              @click="changeLangEvent('en')"
              :class="lang === 'en' ? 'active' : ''"
            >{{ $t('navbar.EnglistLang') }}</span>
            <span class="nav-verbar">/</span>
            <span
              @click="changeLangEvent('zh')"
              :class="lang === 'zh' ? 'active' : ''"
            >{{ $t('navbar.ChineseLang') }}</span>
          </div> -->
          <div class="menulogin">
            <span
              class="pointer"
              @click="showLogin"
              v-if="token || navbarLoginVisible"
            ><i class="iconfont icon-yonghu"></i>
              {{ token ? userInfo.email : $t('navbar.Login') }}
            </span>
            <span
              class="nav-verbar"
              v-if="token"
            >|</span>
            <span
              v-if="token"
              class="pointer"
              @click="signOut()"
            >
              {{ $t('navbar.SignOut') }}
            </span>
            <span v-if="token || navbarLoginVisible" class="nav-verbar">|</span>
            <span
              :class="['pointer',{'existCarts':cartList.length > 0}]"
              @click="showCart"
            ><i class="iconfont icon-shopping"></i>購物袋{{ cartList.length > 0 ? `(${cartList.reduce((total,cart) => total + cart.quantity,0)})` : '' }}</span>
          </div>
        </div>
      </div>
    </nav>
    <login :loginVisible.sync="loginVisible" />
    <cart :cartVisible.sync="cartVisible" />
  </div>
</template>

<script>
import login from '@/components/login'
import cart from '@/components/cart'
import { getInfo } from '@/api/coupon'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'CanvasRebbin',
  props: {
    title: {
      type: String,
      default: ''
    },
    titleObj: {
      type: Object,
      default: null
    },
    couponTitleVisible: {
      type: Boolean,
      default: true
    },
    navbarLoginVisible: {
      type: Boolean,
      default: true
    },
    navbarLogoName: {
      type: String,
      default: 'zhop_logo3.svg'
    },
    navbarLogoLink: {
      type: String,
      default: '/'
    },
    isOTOPage: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      lang: '',
      winLang: localStorage.getItem('lang'),
      indent_style: '',
      validity_period: '05/01/2020 ~ 12/12/2020',
      coupons: [{ couponBannerUrl: '' }],
      // 登录显示与隐藏
      loginVisible: false,
      cartVisible: false,
      loginHeight: 0,
      token: '',
    }
  },
  computed: {
    ...mapState('cart', [
      'cartList'
    ]),
    ...mapState('user', [
      'userInfo'
    ])
  },
  methods: {
    ...mapMutations('user',[
      'setUserInfo',
      'deleteAllUserInfo'
    ]),
    goHome: function (params) {
      this.$router.push({ path: this.navbarLogoLink })
    },
    changeLangEvent: function (params) {
      if (params == 'zh') {
        this.lang = 'zh'
        this.$i18n.locale = this.lang
        // this.$emit('cutoverLang',this.lang)
        window.localStorage.setItem('lang', this.lang)
      } else if (params == 'en') {
        this.lang = 'en'
        this.$i18n.locale = this.lang
        // this.$emit('cutoverLang',this.lang)
        window.localStorage.setItem('lang', this.lang)
      }
    },
    showLogin () {
      if (!this.token) {
        this.loginVisible = true
      } else {
        this.$router.push({ name: 'msGiftCard' })
      }
    },
    showCart () {
      this.cartVisible = true
    },
    async getInfo () {
      if (this.token) {
        const { data: res } = await getInfo().catch(err => {
          this.$notification.error({
            message: 'Error',
            description: 'Session timeout, please login agin.'
          })
          localStorage.removeItem('token')
          this.deleteAllUserInfo()
          this.token = ''
          this.$router.push({ name: 'coupon' })
        })
        this.setUserInfo(res)
      } else {
        this.deleteAllUserInfo()
      }
    },
    // 登出
    signOut () {
      localStorage.removeItem('token')
      this.deleteAllUserInfo()
      console.log(this.$route.name)
      if (this.$route.name === 'coupon' || this.$route.name === 'merchantOTO') {
        window.location.reload()
      } else if (this.isOTOPage) {
        this.$router.push({ name: 'merchantOTO' })
      } else {
        this.$router.push({ name: 'coupon' })
      }
    }
  },
  mounted () {
    if (this.winLang == 'zh') {
      this.lang = 'zh'
      this.$i18n.locale = this.lang
    } else if (this.winLang == 'en') {
      this.lang = 'en'
      this.$i18n.locale = this.lang
    }

    if (location.hash.indexOf('login') >= 0) {
      this.showLogin()
    }
    this.$bus.$on('getInfo', () => {
      this.token = localStorage.getItem('token')
      this.getInfo()
    })
    this.$bus.$on('showCart',this.showCart)
  },
  created () {
    this.token = localStorage.getItem('token')
    this.getInfo()
  },
  components: {
    login,
    cart
  }
}
</script>

<style lang="scss" scoped>
.logo {
  max-width: 120px;
  display: inline-block;
}

.logo img {
  max-width: 100%;
  cursor: pointer;
}

.header {
  background-color: #ffffff;
}

@media (min-width: 768) and(max-width:1280px) {
  .header {
    padding: 0 30px;
  }
}
.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0;
}

.navbar .container-fluid {
  max-width: 1280px;
  margin: 0 auto;
  padding: {
    top: 10px;
    bottom: 10px;
  }
}

.nav-menu {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  height: 100%;
}
.nav-mainTitle {
  // align-self: flex-end;
  // padding-bottom: 8px;
  display: flex;
  font-size: 18px;
  color: #0f96bb;
  > .text-wrap {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    .text-wrap-underline {
      position: relative;
      width: 62px;
      height: 5px;
      border-radius: 3px;
      background-color: #ffbf00;
      &::after {
        content: "";
        position: absolute;
        right: -10px;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: #ffbf00;
      }
    }
  }
  > .text-verbar {
    margin: 0 40px;
  }
}
.nav-language {
  text-align: right;
  font-family: Roboto, "Microsoft YaHei", STHeiTi, sans-serif, simsun;
  font-weight: normal;
  font-size: 16px;
  color: #666666;
  /* display: none; */
}
.nav-language span {
  cursor: pointer;
  &[class="active"] {
    color: #000;
  }
}
.nav-verbar {
  margin-left: 10px;
  margin-right: 10px;
  color: #000000;
  font-weight: lighter;
}
.menulogin {
  font-family: Roboto, Noto Sans CJK TC, "Microsoft YaHei", STHeiTi, sans-serif,
    simsun;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  color: #000000;
  display: flex;
  flex-wrap: wrap;
}
.menulogin > span {
  display: flex;
  align-items: center;
}
.menulogin .iconfont {
  margin-right: 5px;
  font-size: 22px;
  font-weight: 400;
}

@media (max-width: 767px) {
  .navbar {
    position: relative;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-content: center;
    padding: 0.5rem 1rem;
  }
  .nav-mainTitle {
    margin-top: 0px;
    display: none;
  }
  .nav-logo img {
    width: 70%;
  }
}

.pointer {
  cursor: pointer;
}
.existCarts {
  font-weight: bold;
  color: #d4517e;
}
</style>
